// extracted by mini-css-extract-plugin
export default {"actions":"teams_actions__sHk9w"};